/**
 * Send the login form data
 */
window.solicitarRegistro = function (event) {
    event.preventDefault();
    cleanFeedback('solicitarRegistro', 'solicitarRegistroFormulario');

    let formData = new FormData(event.target);

    // Procesamos Recaptcha de Google
    appendGRecaptchaResponse(formData, recaptcha_actions.register).then(function (formData) {

        $.ajax({
            url:         urlRegistro,
            type:        'POST',
            data:        formData,
            processData: false,
            contentType: false,
            beforeSend:  function () {
                $('#solicitarRegistroFormularioBotonEnviar').prop('disabled', true);
                $('#solicitarRegistroFormularioBotonEnviar').html(`<i class="ri-loader-4-line spinner"></i> ${transAccionProcesando}`);
            },
        })
         .done(function (response) {
             $("#solicitarRegistroExito")
                 .show()
                 .find('span')
                 .text(response.message);

             event.target.reset();
             // slideToElement('#solicitarRegistroExito');
             slideToElement('#site-main');
         })
         .fail(function (jqXHR, status, error) {
             if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
                 $('#solicitarRegistroError')
                     .show()
                     .find('span')
                     .html(jqXHR.responseJSON.message);
             } else {
                 showInvalidFeedback(jqXHR, 'solicitarRegistro', 'solicitarRegistroFormulario');
             }
         })
         .always(function () {
             $('#solicitarRegistroFormularioBotonEnviar').prop('disabled', false);
             $('#solicitarRegistroFormularioBotonEnviar').html(`<i class="ri-send-plane-2-fill me-2"></i> ${transAccionEnviar}`);

         });
    }) .catch(function () {
        $("#solicitarRegistroError")
            .show()
            .find("span")
            .text(transGRecaptchaErrorNotValidated);
    });
};

window.changeIconDirection = function (object) {
    $(object).find('i').toggleClass('ri-arrow-up-s-line ri-arrow-down-s-line');
}

window.toggleIbanInput = function (object) {
    let $ibanInputContainer = $('#solicitarRegistroFormularioCampoIban').closest('.form-group');
    if ($(object).val() === 'Giro') {
        $ibanInputContainer.show();
    } else {
        $ibanInputContainer.hide();
    }
}
